
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { buildContentfulImageURL } from '@utils/image';
import Image from '../../../../components/Image';
import s from './FirstLoadWand.module.scss';
import unknown from '../../../../images/profile/unknown.svg';
const propTypes = {
    wand: PropTypes.string.isRequired,
    showWand: PropTypes.bool,
    isRepainting: PropTypes.bool
};
const FirstLoadWand = ({ wand, showWand = true, isRepainting = false }) => {
    const unknownSet = [
        {
            src: unknown
        },
    ];
    const wandSet = [
        {
            src: `${buildContentfulImageURL(wand, {
                width: 56,
                fit: 'fill',
                format: 'webp'
            })} 1x, ${buildContentfulImageURL(wand, {
                width: 112,
                fit: 'fill',
                format: 'webp'
            })} 2x, ${buildContentfulImageURL(wand, {
                width: 178,
                fit: 'fill',
                format: 'webp'
            })} 3x`,
            type: 'image/webp'
        },
        {
            src: `${buildContentfulImageURL(wand, {
                width: 56,
                fit: 'fill',
                format: 'jpg'
            })} 1x, ${buildContentfulImageURL(wand, {
                width: 112,
                fit: 'fill',
                format: 'jpg'
            })} 2x, ${buildContentfulImageURL(wand, {
                width: 178,
                fit: 'fill',
                format: 'jpg'
            })} 3x`,
            type: 'image/jpeg'
        },
        {
            src: buildContentfulImageURL(wand, {
                width: 56,
                fit: 'fill',
                format: 'jpg'
            })
        },
    ];
    return (<>
      <span className={cx(s.wandImageContainer, !isRepainting || showWand ? s.visible : s.hidden)}>
        <Image className={s.wand} imageSet={wandSet} alt="Wand"/>
      </span>
      <span className={cx(s.wandImageContainer, isRepainting ? s.visible : s.hidden)}>
        <Image className={s.unknown} imageSet={unknownSet} alt="Unknown wand"/>
      </span>
    </>);
};
FirstLoadWand.propTypes = propTypes;
export default FirstLoadWand;

    async function __Next_Translate__getStaticProps__195ca0f1669__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: 'src//Profile/components/FirstLoadWand/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__195ca0f1669__ as getStaticProps }
  